<template>
  <div ref="wrapper" class="dropdown_wrapper">
    <slot />
  </div>
</template>
<script>
export default {
  name: "DropdownWrapper",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      boxHeight: 0,
    };
  },
  mounted() {
    if (window) {
      window.addEventListener("resize", this.maybeUpdateDropdownSize);
    }

    document.addEventListener('option-changed-resize', () => this.updateBoxSize())
  },
  watch: {
    open(newVal) {
      if (newVal) {
        this.openBox();
      } else {
        this.closeBox();
      }
    },
  },
  methods: {
    maybeUpdateDropdownSize() {
      const newBoxHeight = this.$refs.wrapper.scrollHeight;
      if (newBoxHeight !== this.boxHeight) {
        this.updateBoxSize();
      }
    },
    updateBoxSize() {
      if (this.open) {
        const newBoxHeight = this.$refs.wrapper.scrollHeight;
        this.boxHeight = newBoxHeight;
        this.$refs.wrapper.style.maxHeight = newBoxHeight + "px";
      }
    },
    closeBox() {
      this.$refs.wrapper.style.maxHeight = null;
    },
    openBox() {
      this.updateBoxSize();
    },
    maybeScrollToHeading() {
      // Only should scroll to the top of secondary ones on open
      if (!this.activeByDefault && this.isOpen) {
        window.scrollTo({
          top: this.$refs.heading.offsetTop,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>
<style scoped>
.dropdown_wrapper {
  height: auto;
  overflow: hidden;
  display: block;
  max-height: 0;
  transition: max-height 0.4s ease-in-out;
}
</style>
